import Box from '@components/base/Box'
import React from 'react'
import { useState } from 'react'
import { MdDragHandle } from 'react-icons/md'

type ResizeableValue = number | 'full'

interface ResizeableProps {
  children: JSX.Element
  enabled?: boolean
  initalSize?: {
    width?: ResizeableValue
    height?: ResizeableValue
  }
  minHeight?: number
  className?: string
  // targetRef: RefObject<T>
}

interface ElementSize {
  width: ResizeableValue
  height: ResizeableValue
}

// interface ResizeablePayload {
//   handler: JSX.Element
//   element: JSX.Element
// }

const Resizeable = ({
  children,
  enabled = true,
  initalSize,
  minHeight = 0,
  className = '',
}: ResizeableProps) => {
  const getInitialSize = () => {
    return { width: 0, height: 0, ...initalSize }
  }

  const [size, setSize] = useState<ElementSize>(getInitialSize())

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    const startSize = size
    const startPosition = { x: e.pageX, y: e.pageY }
    const previousCursor = document.body.style.cursor
    const previousUserSelect = document.body.style.userSelect
    document.body.style.cursor = 'ns-resize'
    document.body.style.userSelect = 'none'

    const onMouseMove = (evt: MouseEvent) => {
      setSize((state) => ({
        ...state,
        height: Math.max(
          minHeight,
          startSize.height === 'full'
            ? 0
            : startSize.height - startPosition.y + evt.pageY,
        ),
      }))
    }

    const onMouseUp = () => {
      document.body.removeEventListener('mousemove', onMouseMove)
      document.body.removeEventListener('mouseup', onMouseUp)
      document.body.style.cursor = previousCursor
      document.body.style.userSelect = previousUserSelect
    }

    document.body.addEventListener('mousemove', onMouseMove)
    document.body.addEventListener('mouseup', onMouseUp)
  }

  const resizeHandle = (
    <span
      className="absolute bottom-0 left-0 z-20 flex h-5 w-full cursor-pointer select-none items-end justify-center"
      onMouseDown={onMouseDown}
      role="separator"
      aria-label="Resize text area"
      aria-orientation="horizontal"
    >
      <MdDragHandle className="pointer-events-none" />
    </span>
  )

  if (!enabled) return <Box className={`relative ${className}`}>{children}</Box>

  const payload = (
    <Box
      className={`relative ${className}`}
      style={{
        height: size.height === 'full' ? '100%' : `${size.height}px`,
        minHeight: `${minHeight}px`,
      }}
    >
      {children}
      {resizeHandle}
    </Box>
  )
  return payload
}

export default Resizeable
